var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DM",
    transform: "translate(0 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M24,0V12.343H0V0ZM.686.686V11.657H23.314V.686Zm10.971,0h.686V11.657h-.686Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_-_Outline",
    "data-name": "Combined-Shape - Outline",
    d: "M-.5-.5h25V12.843H-.5ZM11.157,1.186H1.186v9.971h9.971Zm11.657,0H12.843v9.971h9.971Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M16.646,13.247a2.612,2.612,0,0,0-.569-1.906,1.861,1.861,0,0,0-1.365-.521H12.82v4.862h1.893a1.861,1.861,0,0,0,1.365-.521,2.629,2.629,0,0,0,.569-1.913Zm-.9,0a1.916,1.916,0,0,1-.35,1.365.962.962,0,0,1-.686.274H13.7V11.615h1.008a.962.962,0,0,1,.686.274,1.9,1.9,0,0,1,.35,1.358Z",
    transform: "translate(-8.425 -7.11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M49.762,15.682V10.82H48.631l-1.282,3.463L46.073,10.82H44.88v4.862h.857V12.171l1.255,3.442h.651l1.262-3.4v3.47Z",
    transform: "translate(-29.493 -7.11)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDm);
export default __webpack_public_path__ + "static/media/icon_dm.23ed1eecce5cdc3b41d3dd49e628e14f.svg";
export { ForwardRef as ReactComponent };